import React, { useEffect, useState } from 'react';
import { UserCircle, X } from 'lucide-react';
import CustomModal from '../CustomModal';
import Button from '../../ui/buttons/Button';
import SecondaryButton from '../../ui/buttons/SecondaryButton';
import { fetchWithCsrf } from '../../../utils/fetchWithCsrf';
import { camelizeKeys } from '../../../utils/camelizeKeys';
import { snakecaseKeys } from '../../../utils/snakecaseKeys';
import { useToast } from '../../ui/toast/ToastContext';
import Input from '../../ui/inputs/Input';

const LifeExpectancyModal = ({ clientId, scope, onClose, onSuccess, lifeExpectancy, invalidityLifeExpectancy }) => {
  const { addToast } = useToast();

  const [isSaving, setIsSaving] = useState(false);
  const [lifeExpectancyValue, setLifeExpectancyValue] = useState(lifeExpectancy || 100);
  const [invalidityLifeExpectancyValue, setInvalidityLifeExpectancyValue] = useState(invalidityLifeExpectancy || 100);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'lifeExpectancy') {
      setLifeExpectancyValue(value);
    } else if (name === 'invalidityLifeExpectancy') {
      setInvalidityLifeExpectancyValue(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSaving) return;
    setIsSaving(true);

    try {
      const payload = snakecaseKeys({
        lifeExpectancy: lifeExpectancyValue,
        invalidityLifeExpectancy: invalidityLifeExpectancyValue,
      });

      const res = await fetchWithCsrf(
        `/app/planner/client/${clientId}/dashboard/protections/update_life_expectancy?scope=${scope}`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || 'Falha ao salvar a expectativa de vida');
      }

      addToast({ type: 'success', message: 'Expectativa de vida atualizada com sucesso.' });
      onSuccess && onSuccess();
      onClose && onClose();
    } catch (err) {
      console.error(err);
      addToast({ type: 'error', message: 'Não foi possível salvar a expectativa de vida. Tente novamente.' });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <CustomModal onClose={onClose}>
      <div className="p-10">
        {/* Header */}
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3 text-blueDarker font-jost text-2xl font-semibold">
            <UserCircle size={24} className="text-tealMedium" strokeWidth={1.25} />
            Editar Expectativa de Vida
          </div>
          <button onClick={onClose}>
            <X size={24} className="text-tealBase hover:opacity-80" strokeWidth={1.25} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4 font-jost text-sm">
          <Input
            disabled={isSaving}
            type="number"
            name="lifeExpectancy"
            label="Expectativa de Vida (Morte)"
            value={lifeExpectancyValue}
            onChange={handleChange}
          />
          <Input
            disabled={isSaving}
            type="number"
            name="invalidityLifeExpectancy"
            label="Expectativa de Vida (Invalidez)"
            value={invalidityLifeExpectancyValue}
            onChange={handleChange}
          />

          <div className="flex justify-end items-center md:col-span-2 gap-4">
            <SecondaryButton onClick={onClose}>CANCELAR</SecondaryButton>
            <Button type="submit">SALVAR ALTERAÇÕES</Button>
          </div>
        </form>
      </div>
    </CustomModal>
  );
};

export default LifeExpectancyModal;
